import React from 'react';
import Link from 'next/link';

export default function Footer() {
  return (
    <footer style={{ backgroundColor: '#2C2416', color: '#E8D5A3' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="/assets/images/20b40342-cad4-461f-b81c-952050649b40-1773273486165.jpg"
                alt="香港貝語家居用品有限公司 Logo"
                className="h-16 w-16 object-contain rounded-full"
                style={{ backgroundColor: '#F5F0E8', padding: '4px' }}
              />
              <div>
                <div style={{ color: '#E8D5A3', fontWeight: 700, fontSize: '0.85rem', lineHeight: 1.3 }}>
                  香港貝語家居用品有限公司
                </div>
                <div style={{ color: '#C9A84C', fontSize: '0.6rem', letterSpacing: '0.04em', marginTop: '2px' }}>
                  HONG KONG BEIYU HOUSEHOLD PRODUCTS CO., LIMITED
                </div>
              </div>
            </div>
            <p style={{ color: '#A09070', fontSize: '0.8rem', lineHeight: 1.7 }}>
              專業、誠信、高效<br />
              Professionalism · Integrity · Efficiency
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 style={{ color: '#C9A84C', fontWeight: 700, fontSize: '0.85rem', letterSpacing: '0.08em', marginBottom: '1rem' }}>
              快速導航 NAVIGATION
            </h4>
            <nav className="flex flex-col gap-2">
              {[
                { href: '/', label: '首頁 Home' },
                { href: '/about', label: '關於我們 About Us' },
                { href: '/services', label: '業務範圍 Services' },
                { href: '/register', label: '報名中心 Register' },
                { href: '/contact', label: '聯繫我們 Contact' },
              ]?.map((link) => (
                <Link
                  key={link?.href}
                  href={link?.href}
                  className="text-sm transition-colors duration-200 hover:text-gold-DEFAULT"
                  style={{ color: '#A09070', fontSize: '0.82rem' }}
                >
                  {link?.label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 style={{ color: '#C9A84C', fontWeight: 700, fontSize: '0.85rem', letterSpacing: '0.08em', marginBottom: '1rem' }}>
              聯繫方式 CONTACT
            </h4>
            <div className="flex flex-col gap-3">
              <a
                href="mailto:hhess2071@gmail.com"
                className="flex items-center gap-2 text-sm transition-colors"
                style={{ color: '#A09070' }}
              >
                <svg className="w-4 h-4 flex-shrink-0" style={{ color: '#C9A84C' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                hhess2071@gmail.com
              </a>
              <div className="flex items-start gap-2 text-sm" style={{ color: '#A09070' }}>
                <svg className="w-4 h-4 flex-shrink-0 mt-0.5" style={{ color: '#C9A84C' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span>新界荃灣柴灣角街 66-82 號金熊工業中心<br />66-82 Chai Wan Kok Street, Tsuen Wan, N.T.</span>
              </div>
            </div>
          </div>
        </div>

        <div style={{ borderTop: '1px solid rgba(201,168,76,0.2)', marginTop: '2.5rem', paddingTop: '1.5rem' }} className="flex flex-col sm:flex-row justify-between items-center gap-2">
          <p style={{ color: '#6B5A3E', fontSize: '0.75rem' }}>
            © {new Date()?.getFullYear()} 香港貝語家居用品有限公司. All Rights Reserved.
          </p>
          <p style={{ color: '#6B5A3E', fontSize: '0.75rem' }}>
            HONG KONG BEIYU HOUSEHOLD PRODUCTS CO., LIMITED
          </p>
        </div>
      </div>
    </footer>
  );
}
